/* eslint-disable import/no-unused-modules */
import FamilyTravelBlog from 'components/StartBlog/FamilyTravelBlog';
import withApollo from '../lib/withApollo';

// Product lander of the blogger-intent SEO cluster (docs/seo-plan.md §3).
const FamilyTravelBlogPage = () => <FamilyTravelBlog />;

export default withApollo(FamilyTravelBlogPage);
